<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <div class="page post-job-form">
      <BlacklistAlert v-if="blackList" :id="companyId"
        @cancel="(blackList = false), cancelpost(), chooseCompany(), cancelpost" />

      <div class="page-header">
        <div class="page-header-start">
          <h3 class="page-title">Post Job</h3>
        </div>
        <div class="page-header-end">
          <div class="buttons">
            <button class="button light-grey small" @click="
              $router.push({
                path: 'job-post/online-job',
                query: {
                  type: $route.query.type,
                  p: $route.query.p,
                  q: $route.query.q,
                  s: $route.query.s,
                  sorts: $route.query.sorts,
                },
              })
              ">
              Cancel
            </button>
            <button :class="[
              'button light-primary small',
              { 'is-loading': draftLoading },
            ]" v-if="$route.query.type === 'draft' && $route.query.id" @click="handleSubmit(updateDraft)">
              update as draft
            </button>
            <button :class="[
              'button light-primary small',
              { 'is-loading': draftLoading },
            ]" v-else @click="handleSubmit(saveToDraft)">
              Save as draft
            </button>
            <button :class="['button primary small', { 'is-loading': postLoading }]" v-if="$route.query.id &&
              !$route.query.repost &&
              $route.query.type !== 'draft'
            " @click="handleSubmit(updatePostJob)">
              Update
            </button>
            <button :class="['button primary small', { 'is-loading': postLoading }]" v-else
              @click="handleSubmit(saveAndPublic)">
              Publish
            </button>
          </div>
        </div>
      </div>

      <div class="page-content">
        <label class="publish-toggle">
          <div class="bg" v-if="!isPublished"></div>
          <div class="publish-button" :class="{ inactive: !isPublished }">
            <i class="fa-regular fa-power-off"></i>
            <span v-if="isPublished">ວຽກກຳລັງອອນລາຍຢູ່</span>
            <span v-else>ວຽກກຳລັງອອບລາຍຢູ່ (ຕອນນີ້ຜູ້ໃຊ້ງານຈະບໍ່ເຫັນປະກາດວຽກນີ້)</span>
            <input type="checkbox" v-model="isPublished" @click="isPublished = !isPublished" id="use-published" />
          </div>
        </label>
        <div class="box company-box">
          <div class="box-header">
            <ValidationProvider name="Company" rules="required" v-slot="{ errors }">
              <p class="placeholder" @click="search = true" v-if="afterSelectedCompany">
                {{
                  afterSelectedCompany ? afterSelectedCompany.companyName : ""
                }}
              </p>
              <p class="placeholder" @click="search = true" v-else name="Company">
                Select Company
              </p>
              <span v-if="errors.length" style="color: red">{{
                errors[0]
              }}</span>
              <input type="text" v-model="companyId" hidden="hidden" />
              <div class="seach-box" v-if="search" v-click-outside="() => (search = false)">
                <span class="search-box-title">
                  <span style="color: white">Please choose the company</span>
                  <span @click="search = false">
                    <i style="color: white" class="far fa-times-circle close-btn"></i>
                  </span>
                </span>
                <div class="search">
                  <input v-model="searchText" type="text" class="input" placeholder="Company name"
                    @input="fetchCompany" />
                </div>
                <div class="search-list">
                  <div @click="chooseCompany(c._id, index)" class="search-item" v-for="(c, index) in companies"
                    :key="index">
                    <p>{{ c.companyName }}</p>
                  </div>
                  <infinite-loading v-if="companies.length" spinner="spiral"
                    @infinite="infiniteScroll"></infinite-loading>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <!-- end select company -->

          <div class="box-body">
            <div class="company-control">
              <p v-if="(grayStatus || darkGrayStatus || yellowStatus) &&
                permission !== 'finance'
              " style="color: red">
                ການເງີນເທົ່ານັ້ນທີ່ສາມາດເພີ່ມພ້ອຍໄດ້
              </p>
              <ul>
                <li>
                  <span>Remaining Point:</span>
                  <p v-if="afterSelectedCompany">
                    {{ afterSelectedCompany.point }}
                  </p>
                  <p v-else>0</p>
                </li>
                <li>
                  <input type="text" v-model="pointInput" class="input" placeholder="0" :disabled="(grayStatus || darkGrayStatus || yellowStatus) &&
                    permission !== 'finance'
                    " />
                  <button class="button small" @click="addPoint">
                    Add Point
                  </button>
                </li>
                <li>
                  <input type="text" class="input" v-model="pointDeduct" placeholder="0" :disabled="(grayStatus || darkGrayStatus || yellowStatus) &&
                    permission !== 'finance'
                    " />
                  <button class="button small alert" @click="deductPoint">
                    Deduct Point
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <OrderedBys v-model="orderedBy" :info="selectOrderedBy" :edit="editSelectOrderBy" :error="errOrderedBy"
          v-show="selectOrderedBy.length || editSelectOrderBy.length" />
        <JobDetail v-model="jobDetails" :info="getJobDetail" :jobFunctionLoading="jobFunctionLoading" />
        <EmailNotification v-model="emailNoty" :info="getEmailNoty" />
        <PostPeriod v-model="postDate" :info="getPostDate" />
        <ApplicationSetting v-model="applicationSetting" :info="getApplicationSetting" />
        <DisplyPosition v-model="specialPosition" :info="getSpecialPosition" />
        <JobType v-model="jobType" :info="getJobType" :error="jobTypeError" />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import SelectLanguage from "../others/normalSelect.vue";
import SelectSalary from "../others/normalSelect.vue";
import SelectEducation from "../others/normalSelect.vue";
import SelectWorkingExperience from "../others/normalSelect.vue";
import SelectWorkLocation from "../others/multiSelect.vue";
import JobDetail from "./form/job-detail.vue";
import EmailNotification from "./form/email-notification.vue";
import PostPeriod from "./form/post-period.vue";
import ApplicationSetting from "./form/application-setting.vue";
import DisplyPosition from "./form/display-position.vue";
import JobType from "./form/job-type.vue";
import OrderedBys from "./form/ordered-bys.vue";
import { getEmployersApi, getEmployerId } from "@/apis/employer-api";
import { apolloClient } from "@/services/apollo-client";
import vClickOutside from "v-click-outside";
import { addPointApi, deductPointApi } from "@/apis/point-api";
import moment from "moment";
import BlacklistAlert from "./blacklist-alert.vue";
import {
  postJob,
  get_Edit_Job,
  update_PostJob,
  saveToDraft,
  updateDraft,
} from "@/apis/Job-Post.js";
export default {
  components: {
    SelectLanguage,
    SelectSalary,
    SelectEducation,
    SelectWorkingExperience,
    SelectWorkLocation,
    JobDetail,
    EmailNotification,
    PostPeriod,
    ApplicationSetting,
    DisplyPosition,
    JobType,
    OrderedBys,
    BlacklistAlert,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => ({
    companies: [],
    companyId: "",
    search: false,
    selectOrderedBy: [],
    orderedBy: [],
    editSelectOrderBy: [],
    errOrderedBy: "",
    blackList: null,
    grayStatus: false,
    darkGrayStatus: false,
    yellowStatus: false,
    permission: "",
    searchText: "",
    //end company variable
    pointInput: null,
    pointDeduct: null,
    //end point variable
    jobDetails: null,
    getJobDetail: {},
    //end Job detail variable
    emailNoty: null,
    getEmailNoty: null,
    //end notification email variable
    postDate: null,
    getPostDate: null,
    period: 1,
    //end post date variable
    applicationSetting: null,
    getApplicationSetting: null,
    //end Application Setting variable
    specialPosition: null,
    getSpecialPosition: null,
    //end Special position variable
    jobType: null,
    getJobType: null,
    jobTypeError: "",
    //End Job type variable
    errorMessage: "",
    postLoading: false,
    draftLoading: false,
    page: 1,
    perPage: 20,
    isPublished: true,
    jobFunctionLoading: true
  }),
  computed: {
    // getCompanyList() {
    //   return this.companies.filter((i) => {
    //     return i.companyName.toLowerCase().match(this.searchText.toLowerCase());
    //   })
    // },
    afterSelectedCompany() {
      return this.companies.find((i) => {
        return i._id === this.companyId;
      });
    },
  },
  methods: {
    async fetchCompany() {
      let isPage = this.page;
      if (this.searchText) isPage = 1;
      const form = {
        page: isPage,
        perPage: this.perPage,
        search: this.searchText,
      };
      const companies = await getEmployersApi(form);
      this.companies = companies;
    },
    async infiniteScroll($state) {
      setTimeout(async () => {
        this.page++;
        const form = {
          page: this.page,
          perPage: this.perPage,
          search: this.searchText,
        };
        const companies = await getEmployersApi(form);
        if (companies.length > 1) {
          this.companies.push(...companies);
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 500);
    },

    chooseCompany(companyId) {
      this.search = false;
      this.companyId = companyId;
      const company = this.companies.find((i) => i._id === companyId);
      if (!company) return;
      this.getApplicationSetting = { appliedEmails: company.appliedEmails, isCoverLetter: false };
      this.getEmailNoty = {
        nortificationEmails: company.nortificationEmails,
        notifyExpire: company.notifyExpire ? company.notifyExpire : "",
      };
      this.selectOrderedBy = company.orderedBy;
      this.blackList = company.blacklist;
      this.grayStatus = company.grayStatus;
      this.darkGrayStatus = company.darkGrayStatus;
      this.yellowStatus = company.yellowStatus;
    },
    // add point to company function
    async addPoint() {
      if (
        (this.grayStatus || this.darkGrayStatus || this.yellowStatus) &&
        this.permission !== "finance"
      )
        return;
      if (!this.pointInput) return;
      const form = {
        point: parseInt(this.pointInput, 10),
        EmployerId: this.afterSelectedCompany._id,
      };
      await addPointApi(form);
      this.pointInput = null;
      this.fetchCompany();
      const isId = { id: this.afterSelectedCompany._id };
      const res = await getEmployerId(isId);
      this.companies.push(res);
    },
    async deductPoint() {
      if (
        (this.grayStatus || this.darkGrayStatus || this.yellowStatus) &&
        this.permission !== "finance"
      )
        return;
      if (!this.pointDeduct) return;
      const form = {
        point: parseInt(this.pointDeduct, 10),
        EmployerId: this.afterSelectedCompany._id,
      };
      await deductPointApi(form)
        .then(async () => {
          this.pointDeduct = null;
          this.fetchCompany();
          const isId = { id: this.afterSelectedCompany._id };
          const res = await getEmployerId(isId);
          this.companies.push(res);
        })
        .catch(async ({ graphQLErrors }) => {
          await this.$dialog.messageError(graphQLErrors[0].message);
        });
    },
    // End add point to company
    async cancelpost() {
      this.$router.go(0);
    },
    //End Cancel post function
    async saveToDraft() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      if (!this.jobType.isBasic && !this.jobType.jopmai) {
        this.jobTypeError = "Please Check this Job is Basic or Jopmai";
        return;
      }
      this.jobTypeError = "";
      if (!this.orderedBy.length) {
        this.errOrderedBy = "Please check Ordered By";
        return;
      }
      this.errOrderedBy = "";
      const form = {
        employerId: this.companyId,
        title: this.jobDetails.title,
        description: this.jobDetails.jobDescription,
        jobFunctionId: this.jobDetails.jobFunctionId.map((i) => i._id),
        workingLocationId: this.jobDetails.workingLocation.map((i) => i._id),
        jobExperienceId: this.jobDetails.workingExperience,
        jobLanguageId: this.jobDetails.preLanguage.map((i) => i._id),
        jobEducationLevelId: this.jobDetails.educationLevel,
        salayRangeId: this.jobDetails.salaryRange,
        isShowSalary: this.jobDetails.isShowSalary,
        staffQTY: this.jobDetails.staffQTY,
        tagIds: this.specialPosition.tagId,
        jobZoneIds: this.specialPosition.jobZoneId,
        jobLevelId: this.jobDetails.jobLevelId,
        image: this.specialPosition.file,
        openingDate: this.postDate.openingDate,
        closingDate: this.postDate.closingDate,
        expiredDate: this.postDate.expiredDate,
        isApplyUrl: this.applicationSetting.isApplyUrl,
        isCoverLetter: this.applicationSetting.isCoverLetter,
        isNotApply: this.applicationSetting.isNotApply,
        isHideApplyButton: this.applicationSetting.isHideApplyButton,
        appliedEmails: this.applicationSetting.appliedEmails,
        isURL: this.applicationSetting.isURL,
        nortificationEmails: this.emailNoty.nortificationEmails,
        notifyExpire: this.emailNoty.notifyExpire,
        isPublished: this.isPublished,
        isBasic: this.jobType.isBasic,
        orderedBy: this.orderedBy,
        jopmai: this.jobType.jopmai,
        disabledPeople: this.jobType.disabledPeople ? this.jobType.disabledPeople : false
      };
      this.draftLoading = true;
      await saveToDraft(form)
        .then(() => {
          this.draftLoading = false;
          this.$router.push({
            path: "job-post/online-job",
            query: {
              type: this.$route.query.type,
              p: this.$route.query.p,
              q: this.$route.query.q,
              s: this.$route.query.s,
              sorts: this.$route.query.sorts,
            },
          });
        })
        .catch(async ({ graphQLErrors }) => {
          const errorText = graphQLErrors[0].message;
          if (errorText) {
            this.draftLoading = false;
            const isConfirmed = await this.$dialog.alert(errorText);
            if (!isConfirmed) return;
          }
        });
    },
    async updateDraft() {
      if (!this.$route.query.id) return;
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      if (!this.jobType.isBasic && !this.jobType.jopmai) {
        this.jobTypeError = "Please Check this Job is Basic or Jopmai";
        return;
      }
      this.jobTypeError = "";
      if (!this.orderedBy.length) {
        this.errOrderedBy = "Please check Ordered By";
        return;
      }
      this.errOrderedBy = "";
      const form = {
        _id: this.$route.query.id,
        employerId: this.companyId,
        title: this.jobDetails.title,
        description: this.jobDetails.jobDescription,
        jobFunctionId: this.jobDetails.jobFunctionId.map((i) => i._id),
        workingLocationId: this.jobDetails.workingLocation.map((i) => i._id),
        jobExperienceId: this.jobDetails.workingExperience,
        jobLanguageId: this.jobDetails.preLanguage.map((i) => i._id),
        jobEducationLevelId: this.jobDetails.educationLevel,
        salayRangeId: this.jobDetails.salaryRange,
        isShowSalary: this.jobDetails.isShowSalary,
        staffQTY: this.jobDetails.staffQTY,
        tagIds: this.specialPosition.tagId,
        jobZoneIds: this.specialPosition.jobZoneId,
        jobLevelId: this.jobDetails.jobLevelId,
        image: this.specialPosition.file,
        openingDate: this.postDate.openingDate,
        closingDate: this.postDate.closingDate,
        expiredDate: this.postDate.expiredDate,
        isApplyUrl: this.applicationSetting.isApplyUrl,
        isCoverLetter: this.applicationSetting.isCoverLetter,
        isNotApply: this.applicationSetting.isNotApply,
        isHideApplyButton: this.applicationSetting.isHideApplyButton,
        appliedEmails: this.applicationSetting.appliedEmails,
        isURL: this.applicationSetting.isURL,
        nortificationEmails: this.emailNoty.nortificationEmails,
        notifyExpire: this.emailNoty.notifyExpire,
        isPublished: this.isPublished,
        isBasic: this.jobType.isBasic,
        orderedBy: this.orderedBy,
        jopmai: this.jobType.jopmai,
        disabledPeople: this.jobType.disabledPeople
      };
      this.draftLoading = true;
      await updateDraft(form)
        .then(() => {
          this.draftLoading = false;
          this.$router.push({
            path: "job-post/online-job",
            query: {
              type: this.$route.query.type,
              p: this.$route.query.p,
              q: this.$route.query.q,
              s: this.$route.query.s,
              sorts: this.$route.query.sorts,
            },
          });
        })
        .catch(async ({ graphQLErrors }) => {
          const errorText = graphQLErrors[0].message;
          if (errorText) {
            this.draftLoading = false;
            const isConfirmed = await this.$dialog.alert(errorText);
            if (!isConfirmed) return;
          }
        });
    },
    // End Save to draft function
    async saveAndPublic() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      if (!this.jobType.isBasic && !this.jobType.jopmai) {
        this.jobTypeError = "Please Check this Job is Basic or Jopmai";
        return;
      }
      this.jobTypeError = "";
      if (!this.orderedBy.length) {
        this.errOrderedBy = "Please check Ordered By";
        return;
      }
      this.errOrderedBy = "";
      let draftId = "";
      if (this.$route.query.type === "draft") draftId = this.$route.query.id;
      const form = {
        employerId: this.companyId,
        title: this.jobDetails.title,
        description: this.jobDetails.jobDescription,
        jobFunctionId: this.jobDetails.jobFunctionId.map((i) => i._id),
        workingLocationId: this.jobDetails.workingLocation.map((i) => i._id),
        jobExperienceId: this.jobDetails.workingExperience,
        jobLanguageId: this.jobDetails.preLanguage.map((i) => i._id),
        jobEducationLevelId: this.jobDetails.educationLevel,
        salayRangeId: this.jobDetails.salaryRange,
        isShowSalary: this.jobDetails.isShowSalary,
        staffQTY: this.jobDetails.staffQTY,
        tagIds: this.specialPosition.tagId,
        jobZoneIds: this.specialPosition.jobZoneId,
        jobLevelId: this.jobDetails.jobLevelId,
        image: this.specialPosition.file,
        openingDate: this.postDate.openingDate,
        closingDate: this.postDate.closingDate,
        expiredDate: this.postDate.expiredDate,
        isApplyUrl: this.applicationSetting.isApplyUrl,
        isCoverLetter: this.applicationSetting.isCoverLetter,
        isNotApply: this.applicationSetting.isNotApply,
        isHideApplyButton: this.applicationSetting.isHideApplyButton,
        appliedEmails: this.applicationSetting.appliedEmails,
        isURL: this.applicationSetting.isURL,
        nortificationEmails: this.emailNoty.nortificationEmails,
        notifyExpire: this.emailNoty.notifyExpire,
        isPublished: this.isPublished,
        isBasic: this.jobType.isBasic,
        orderedBy: this.orderedBy,
        jopmai: this.jobType.jopmai,
        disabledPeople: this.jobType.disabledPeople ? this.jobType.disabledPeople : false,
        draftId,
      };
      this.postLoading = true;
      await postJob(form)
        .then(() => {
          this.postLoading = false;
          this.$router.push({
            path: "job-post/online-job",
            query: {
              type: this.$route.query.type,
              p: this.$route.query.p,
              q: this.$route.query.q,
              s: this.$route.query.s,
              sorts: this.$route.query.sorts,
            },
          });
        })
        .catch(async ({ graphQLErrors }) => {
          const errorText = graphQLErrors[0].message;
          if (errorText) {
            this.postLoading = false;
            const isConfirmed = await this.$dialog.alert(errorText);
            if (!isConfirmed) return;
          }
        });
    },
    async editPostJob() {
      const _id = this.$route.query.id;
      if (!_id) return;
      this.jobFunctionLoading = true
      const res = await get_Edit_Job({ id: _id });
      this.companyId = res.employerId._id;
      this.companies.push(res.employerId);
      this.editSelectOrderBy = res.orderedBy;
      this.isPublished = res.isPublished;
      setTimeout(() => {
        this.getJobDetail = {
          title: res.title,
          staffQTY: res.staffQTY,
          jobFunctionId: res.jobFunctionId,
          workingLocation: res.workingLocationId,
          workingExperience: res.jobExperienceId._id,
          jobLevelId: res.jobLevelId ? res.jobLevelId._id : "",
          educationLevel: res.jobEducationLevelId._id,
          preLanguage: res.jobLanguageId,
          salaryRange: res.salayRangeId._id,
          jobDescription: res.description,
          isShowSalary: res.isShowSalary,
        };
        setTimeout(() => {
          this.jobFunctionLoading = false
        })
      })

      this.getEmailNoty = {
        nortificationEmails: res.nortificationEmails,
        notifyExpire: res.notifyExpire,
      };
      if (this.$route.query.repost === "repost") {
        const openingDate = new Date();
        let expiredDate;
        let closingDate;
        if (openingDate) {
          expiredDate = moment(openingDate).add(
            7 * parseInt(this.period, 10) - 1,
            "days"
          )._d;
          closingDate = moment(openingDate).add(
            7 * parseInt(this.period, 10) - 1,
            "days"
          )._d;
        }
        this.getPostDate = {
          openingDate: new Date(openingDate),
          closingDate: new Date(closingDate),
          expiredDate: new Date(expiredDate),
        };
      } else {
        this.getPostDate = {
          openingDate: new Date(res.openingDate),
          closingDate: new Date(res.closingDate),
          expiredDate: new Date(res.expiredDate),
        };
      }
      this.getApplicationSetting = {
        isApplyUrl: res.isApplyUrl,
        isCoverLetter: res.isCoverLetter,
        isNotApply: res.isNotApply,
        isHideApplyButton: res.isHideApplyButton,
        appliedEmails: res.appliedEmails,
        isURL: res.isURL,
      };
      this.getSpecialPosition = {
        tagId: res.tagIds.map((i) => i._id),
        jobZoneId: res.jobZoneIds.map((i) => i._id),
        file: res.image,
      };
      this.getJobType = {
        isBasic: res.isBasic,
        jopmai: res.jopmai,
        disabledPeople: res.disabledPeople ? res.disabledPeople : false
      };
    },
    async updatePostJob() {
      try {
        const isConfirmed = await this.$dialog.confirm();
        if (!isConfirmed) return;
        if (!this.$route.query.id) return;
        if (!this.jobType.isBasic && !this.jobType.jopmai) {
          this.jobTypeError = "Please Check this Job is Basic or Jopmai";
          return;
        }
        this.jobTypeError = "";
        if (!this.orderedBy.length) {
          this.errOrderedBy = "Please check Ordered By";
          return;
        }
        this.errOrderedBy = "";
        const form = {
          jobId: this.$route.query.id,
          employerId: this.companyId,
          title: this.jobDetails.title,
          description: this.jobDetails.jobDescription,
          jobFunctionId: this.jobDetails.jobFunctionId.map((i) => i._id),
          workingLocationId: this.jobDetails.workingLocation.map((i) => i._id),
          jobExperienceId: this.jobDetails.workingExperience,
          jobLanguageId: this.jobDetails.preLanguage.map((i) => i._id),
          jobEducationLevelId: this.jobDetails.educationLevel,
          salayRangeId: this.jobDetails.salaryRange,
          isShowSalary: this.jobDetails.isShowSalary,
          staffQTY: this.jobDetails.staffQTY,
          tagIds: this.specialPosition.tagId,
          jobZoneIds: this.specialPosition.jobZoneId,
          jobLevelId: this.jobDetails.jobLevelId,
          image: this.specialPosition.file,
          openingDate: this.postDate.openingDate,
          closingDate: this.postDate.closingDate,
          expiredDate: this.postDate.expiredDate,
          isApplyUrl: this.applicationSetting.isApplyUrl,
          isCoverLetter: this.applicationSetting.isCoverLetter,
          isNotApply: this.applicationSetting.isNotApply,
          isHideApplyButton: this.applicationSetting.isHideApplyButton,
          appliedEmails: this.applicationSetting.appliedEmails,
          isURL: this.applicationSetting.isURL,
          nortificationEmails: this.emailNoty.nortificationEmails,
          notifyExpire: this.emailNoty.notifyExpire,
          isPublished: this.isPublished,
          isBasic: this.jobType.isBasic,
          orderedBy: this.orderedBy,
          jopmai: this.jobType.jopmai,
          disabledPeople: this.jobType.disabledPeople ? this.jobType.disabledPeople : false
        };
        this.postLoading = true;
        await update_PostJob(form)
          .then(() => {
            this.postLoading = false;
            this.$router.push({
              path: "job-post/online-job",
              query: {
                type: this.$route.query.type,
                p: this.$route.query.p,
                q: this.$route.query.q,
                s: this.$route.query.s,
                sorts: this.$route.query.sorts,
              },
            });
          })
          .catch(async ({ graphQLErrors }) => {
            const errorText = graphQLErrors[0].message;
            if (errorText) {
              this.postLoading = false;
              const isConfirmed = await this.$dialog.alert(errorText);
              if (!isConfirmed) return;
            }
          });
      } catch (e) {
        throw new Error(e);
      }
    },
  },
  created() {
    this.fetchCompany();
    this.editPostJob();
  },
  watch: {
    "$store.getters.isAuthInfo": {
      handler() {
        if (
          this.$store.getters.isAuthInfo &&
          this.$store.getters.isAuthInfo !== null
        ) {
          this.permission = this.$store.getters.isAuthInfo;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.publish-toggle {
  .bg {
    backdrop-filter: blur(2px);
    background-color: rgba(#000, 0.15);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .publish-button {
    height: 2.5rem;
    display: inline-flex;
    align-items: center;
    padding: 0 15px;
    background-color: var(--light-grey-color) !important;
    color: var(--grey-text-color);
    border-radius: 6px;
    margin-bottom: 20px;
    border: 1px solid var(--grey-text-color) !important;
    cursor: pointer;
    position: relative;
    z-index: 2;

    i {
      margin-right: 10px;
    }

    &.inactive {
      background-color: var(--alert-color) !important;
      color: #fff;
      border-color: var(--alert-color) !important;
    }

    input {
      display: none;
    }
  }
}

.post-job-form {
  .page-content {
    padding: 20px;

    .company-box {
      .box-header {
        cursor: pointer;
        transition: all ease-in-out 0.15s;
        border-radius: 6px 6px 0 0;
        border: 1px solid var(--primary-color);
        position: relative;
        display: flex;
        align-items: center;
        height: 3rem !important;
        background-color: rgba(var(--primary-color-rgb), 0.09) !important;

        &:hover {
          background-color: var(--primary-color) !important;

          .placeholder {
            color: #fff;
          }
        }

        .placeholder {
          margin: 0;
          cursor: pointer;
          color: var(--primary-color);
        }
      }

      .seach-box {
        z-index: 1;
        position: relative;
        padding-top: 12px;
        width: 100%;
        border-radius: 5px;
        background-color: var(--primary-color);
        box-shadow: 0 0px 20px 10px rgba(#000, 0.15);
        top: -5px;
        left: 0;
        right: 0;
        position: absolute;

        .close-btn {
          margin-left: auto;
          cursor: pointer;
        }

        .search-box-title {
          padding: 0 20px;
          display: flex;
          justify-content: space-between;

          &:hover {
            color: inherit;
          }
        }

        .search {
          padding: 10px 20px 20px;

          input {
            background-color: var(--light-grey-color);
            box-shadow: none;
            box-shadow: unset;
            box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
          }
        }

        .search-list {
          border: 1px solid var(--border-color);
          background-color: #fff;
          padding: 20px;
          padding: 0;
          display: block;
          height: 280px;
          overflow-y: scroll;

          .search-item {
            font-size: 14px;
            white-space: pre-line;
            margin: 0;
            padding: 10px 20px;
            transition: all ease-in-out 0.1s;
            cursor: pointer;

            &:not(:last-child) {
              border-bottom: 1px solid var(--border-color);
            }

            &:hover {
              background-color: #dbdbdb;
            }

            p {
              margin: 0;
            }
          }
        }
      }

      .box-body {
        padding: 0;

        .company-control {
          ul {
            display: flex;
            list-style-type: none;
            margin: 0;
            padding: 0;
            background-color: var(--light-grey-color);

            li {
              font-size: var(--xsm-font);
              padding: 0 20px;
              height: 3.5rem;
              display: flex;
              align-items: center;
              gap: 5px;
              color: var(--text-color);

              &:not(:last-child) {
                border-right: 1px solid var(--border-color);
              }

              input {
                background-color: #fff;
                font-size: var(--sm-font);
                text-align: center;
                width: 100px;
              }

              span {
                margin: 0 !important;
                font-size: var(--sm-font);
              }

              p {
                font-size: var(--md-font);
                font-weight: 700;
                color: var(--primary-color);
              }

              button {
                background-color: rgba(var(--primary-color-rgb), 0.09);
                color: var(--primary-color);

                &.alert {
                  background-color: rgba(var(--alert-color-rgb), 0.09);
                  color: var(--alert-color);
                }
              }
            }
          }
        }
      }
    }
  }

  .box {
    border: 1px solid var(--border-color);
    padding: 0;
    margin-bottom: 20px;

    .box-header {
      border-bottom: 1px solid var(--border-color);
      padding: 20px;
      margin-bottom: 0;
      background-color: var(--grey-color);
      height: 2rem;
      display: flex;
      align-items: center;

      h3 {
        text-transform: uppercase;
        font-weight: 800;
        font-size: var(--xsm-font);
        margin: 0;
        color: var(--text-color);

        span {
          color: var(--primary-color) !important;
        }
      }
    }

    // box-header
    .box-body {
      padding: 20px;
    }
  }

  .field {
    margin-bottom: 20px;

    &.no-margin {
      margin: 0;
    }

    .label {
      font-size: var(--xsm-font);
      font-weight: 500;
      margin-bottom: 5px;
      color: var(--text-color) !important;

      span {
        margin-left: 5px;
        font-weight: normal;
        color: var(--dark-grey-color) !important;
      }
    }
  }

  .input-group {
    .field {
      margin: 0 !important;
    }

    .control {
      margin-bottom: 10px;
      position: relative;

      &.has-icon {
        display: flex;
        align-items: center;
        position: relative;

        i {
          width: 30px;
          text-align: center;
          cursor: pointer;
          transition: all ease-in-out 0.3s;
          color: var(--danger-color);

          &:hover {
            font-weight: 700;
          }
        }

        input {
          position: relative;
          padding-right: 30px;
        }
      }
    }
  }
}

.company-selector {
  border: 1px solid var(--border-color);
  padding: 20px;
  margin-bottom: 20px;
  border-radius: var(--radius);
}
</style>
